import { IpponCard, IpponContainer, IpponTitle, IpponVSpace } from '@ippon-ui/react';
import { useTranslation } from 'react-i18next';
import { LoadingErrorComponent } from '@/generic/loader';

export const DiagnosticHistoryErrorComponent = ({ error }: { error: Error }) => {
  const { t } = useTranslation('diagnostic');

  return (
    <IpponContainer>
      <IpponCard size="large" shadow="l3">
        <IpponVSpace gap={10}>
          <IpponTitle tag="h2" level={5} dataSelector="diagnostic.history.title">
            {t('diagnostic.history.title')}
          </IpponTitle>
          <LoadingErrorComponent error={error} dataSelector="diagnostic.history.error" />
        </IpponVSpace>
      </IpponCard>
    </IpponContainer>
  );
};
